import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_tien_gui_hach_toan_giay_bao_no_GBN } from '@/lib/templates-base64/GBN';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { useGiayBaoNoSearchContext } from '../context';

interface ActionBarProps {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onPrint?: () => void;
  onSearch?: () => void;
  onRefresh?: () => void;
  onImportFromExcelClick?: () => void;
}

export default function ActionBar({
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onPrint,
  onSearch,
  onRefresh,
  onImportFromExcelClick
}: ActionBarProps) {
  const { exportToExcel } = useGiayBaoNoSearchContext();
  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(excelTemplate_tien_gui_hach_toan_giay_bao_no_GBN, 'Giấy báo nợ.xlsx');
  };

  return (
    <ActionBarV2 title='Giấy báo nợ'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} />
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrint} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcelClick || (() => {}),
            group: 3
          }
        ]}
      />
    </ActionBarV2>
  );
}
